import { useDebounce } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export enum ConnectivityStatus {
  ONLINE = 'connected',
  CONNECTING = 'connecting',
  OFFLINE = 'disconnected',
}

export const useAppStore = defineStore('appStore', () => {
  const userIsLoading = ref(true);
  const conversationsAreLoading = ref(true);
  const connectivityStatusUnDebounced = ref<ConnectivityStatus>(
    ConnectivityStatus.ONLINE,
  );
  const connectivityStatus = useDebounce(connectivityStatusUnDebounced, 3000);
  const isStandaloneChat = ref(false);

  const showSideBarMobile = ref<boolean>(true);

  const isLoading = computed(
    () => userIsLoading.value || conversationsAreLoading.value,
  );

  async function bootstrap(standalone = false): Promise<void> {
    isStandaloneChat.value = standalone;
  }

  function setConnectivityStatus(value: ConnectivityStatus): void {
    connectivityStatusUnDebounced.value = value;
  }

  const toggleSidebarMobile = (isOpen: boolean): void => {
    showSideBarMobile.value = isOpen;
  };

  return {
    isLoading,
    connectivityStatus,
    showSideBarMobile,
    isStandaloneChat,
    bootstrap,
    setConnectivityStatus,
    toggleSidebarMobile,
  };
});
